import React, { useState } from "react";
import { getUrl } from "@outplayed/riot-assets";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { Carousel } from "react-responsive-carousel";
import isBrowser from "is-in-browser";

if (isBrowser) {
  require("react-responsive-carousel/lib/styles/carousel.min.css");
}

const PerformanceAnalysisBestAndWorstCarousel = (props) => {
  const { getChampionSplashImg } = getRiotAssetsContext();
  const { bestAndWorstData } = props;

  if (!bestAndWorstData) {
    return <div />;
  }

  const { diedToMost, killedMost, lostAgainstMost, wonAgainstMost } = bestAndWorstData;
  let slides = [
    { icon: "white_two_sword_icon.png", championId: diedToMost.championId, label: "DIED TO MOST", value: diedToMost.deaths },
    { icon: "white_sword_icon.png", championId: killedMost.championId, label: "KILLED MOST", value: killedMost.kills },
    {
      icon: "white_two_sword_icon.png",
      championId: lostAgainstMost.championId,
      label: "LOST TO MOST",
      value: lostAgainstMost.loses,
    },
    {
      icon: "white_sword_icon.png",
      championId: wonAgainstMost.championId,
      label: "WON AGAINST MOST",
      value: wonAgainstMost.wins,
    },
  ];

  slides = slides.filter((slide) => {
    return slide.championId > 0;
  });
  const [carouselIndex, setCarouselIndex] = useState(0);

  const incrementCarousel = (amount) => {
    let newIndex = carouselIndex + amount;
    if (newIndex < 0) newIndex = slides.length - 1;
    if (newIndex > slides.length) newIndex = 0;
    setCarouselIndex(newIndex);
  };

  return (
    <div className="best-and-worst-widget">
      <div className="text-container">
        <div className="small-header">BEST & WORST</div>
        <div className="basic-text">We all have bad days. Yours are when you play these champs.</div>
        <div className="basic-text">We put your best ones here too, for science.</div>
      </div>
      <div className="carousel-container">
        <img
          className="carousel-arrow"
          src={getUrl(`lol/performance_analysis/icons/left_carousel_arrow.svg`)}
          onClick={() => incrementCarousel(-1)}
        />
        <div className="carousel">
          <Carousel
            showThumbs={false}
            width="750px"
            showIndicators={false}
            showArrows={false}
            showStatus={false}
            selectedItem={carouselIndex}
          >
            {slides.map((slideData, index) => {
              const backgroundImage = getChampionSplashImg(slideData.championId);
              return (
                <div key={index}>
                  <div className="carousel-element" style={{ backgroundImage: `url("${backgroundImage}")` }}>
                    <div className="background-darken" />
                    <div></div>
                    <div className="carousel-bottom">
                      <div className="left-section">
                        <img src={getUrl(`lol/performance_analysis/icons/${slideData.icon}`)} />
                        <div className="label-text">{slideData.label}</div>
                      </div>
                      <div className="right-section">
                        <div className="bold-text">{slideData.value}&nbsp;</div>
                        <div className="normal-text">TIMES</div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Carousel>
        </div>
        <img
          className="carousel-arrow"
          src={getUrl(`lol/performance_analysis/icons/right_carousel_arrow.svg`)}
          onClick={() => incrementCarousel(1)}
        />
      </div>
    </div>
  );
};

export default PerformanceAnalysisBestAndWorstCarousel;
